var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nomess"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }